import React from 'react';
import { Archive, Trash2 } from 'lucide-react';

export default function ConfirmDialog({ confirmDialog, setConfirmDialog }) {
  if (!confirmDialog) return null;
  const isArchive = confirmDialog.message?.includes('Archive');
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[60] p-4" onClick={e => { if (e.target === e.currentTarget) setConfirmDialog(null); }}>
      <div className="bg-white rounded-2xl w-full max-w-sm shadow-2xl overflow-hidden">
        <div className="p-6">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 ${isArchive ? 'bg-amber-100' : 'bg-red-100'}`}>
            {isArchive ? <Archive className="w-6 h-6 text-amber-600" /> : <Trash2 className="w-6 h-6 text-red-600" />}
          </div>
          <h3 className="text-lg font-semibold text-gray-900 text-center">{isArchive ? 'Archive Item' : 'Confirm Delete'}</h3>
          <p className="text-sm text-gray-500 text-center mt-2">{confirmDialog.message}</p>
          <p className="text-xs text-gray-400 text-center mt-1">{isArchive ? 'You can still view archived items in reports.' : 'This action cannot be undone.'}</p>
        </div>
        <div className="flex border-t">
          <button onClick={() => setConfirmDialog(null)} className="flex-1 py-3 text-sm font-medium text-gray-600 hover:bg-gray-50 border-r transition-colors">Cancel</button>
          <button onClick={confirmDialog.onConfirm} className={`flex-1 py-3 text-sm font-medium transition-colors ${isArchive ? 'text-amber-600 hover:bg-amber-50' : 'text-red-600 hover:bg-red-50'}`}>
            {isArchive ? 'Archive' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
